
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ProblemPassageContent from '@/components/organisms/ProblemPassageContent.vue'
import LearningProgressTip from '@/components/organisms/LearningProgressTip.vue'
import { LearningProblemCurriculumUnit } from '@/models/LearningProblemCurriculumUnit'
import { LearningProgress } from '@/const/LearningProgress'

/**
 * 単元別問題選択 履歴問題
 */
@Component({
  components: {
    ImageBase,
    ProblemPassageContent,
    LearningProgressTip,
  },
})
export default class ProblemPassageHistroy extends Vue {
  /** 問題情報 */
  @Prop()
  private problemHistory!: LearningProblemCurriculumUnit.History

  /** 線の有無 */
  @Prop()
  private showLine!: boolean

  /** 履歴問題クリック時のイベント */
  @Prop()
  private eventClickHistoryProblem!: (problemCode: string, level: number) => Promise<void>

  /** 履歴ボタン押下時のイベント */
  @Prop()
  private eventClickHistroyButton!: (id: number) => void

  /**
   * 学習レベルから学習進捗マスターを引き当てる
   *
   * @returns 学習進捗マスター
   */
  private get progress(): LearningProgress.LearningProgressMaster {
    return LearningProgress.findByLevel(this.problemHistory.level)
  }

  /**
   * 履歴ボタン押下イベントのラッパーメソッド(引数があるためラップする)
   */
  private onClickHistoryButton(): void {
    this.eventClickHistroyButton(this.problemHistory.id)
  }

  /**
   * 履歴問題クリックイベントのラッパーメソッド(引数があるためラップする)
   */
  private async onClickHistoryProblem(): Promise<void> {
    await this.eventClickHistoryProblem(this.problemHistory.problemCode, this.problemHistory.level)
  }
}
